import React from "react";

const DataContext = React.createContext({
  pageData: -1,
  categories: -1,
  galleries: -1,
  references: -1,
  lang: {
    id: 0,
    lang: "hr",
  },
  setHash: () => {},
});

export default DataContext;
